import { GET_SEARCH_RESULTS, EMPTY_SEARCHES } from './actions';
import { REQUEST, SUCCESS } from 'utils/actionGenerator';
import _get from 'lodash/get';

const defaultState = {};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_SEARCH_RESULTS[REQUEST]:
      return { ...state, searchResults: [] };
    case GET_SEARCH_RESULTS[SUCCESS]:
      return { ...state, searchResults: action.response.data.data ?? [] };
    case EMPTY_SEARCHES:
      return { ...state, searchResults: [] };
    default:
      return state;
  }
}

export const getSearchResults = (state) => _get(state, 'places.searchResults', []);
